import { Schema, arrayOf } from 'normalizr';

import { segmentSchema } from 'state/segments/schema/segmentsSchema';
import { tileSchema } from 'state/tiles/schema/tilesSchema';

export const editionSchema = new Schema('edition', { idAttribute: 'id' });
editionSchema.define({ tiles: arrayOf(tileSchema) });
editionSchema.define({ segments: arrayOf(segmentSchema) });
